import React, { useCallback, useMemo, useState } from "react";

import { AxiosError } from "axios";
import LoadingAndErrorBoundary from "../../../../commons/LoadingAndErrorBoundary";
import {
  LoadingIndicator,
  LoadingOverlay,
  RenderWhen
} from "../../../../../components";
import RlCloudSandboxCarouselWrapper from "./RlCloudSandboxCarouselWrapper";
import ScreenshotsErrorMessage from "./ScreenshotsErrorMessage";
import Reanalyze from "../../reanalyze/reanalyze-popup/Reanalyze";
import { INITIAL_ANALYSIS_SELECTIONS } from "../../reanalyze/reanalyze-popup/consts";

type Props = {
  hash: string;
  isNetwork: boolean;
  activeAnalysisId: string;
  loadingIndicator?: boolean;
};

type ErrorFallbackProps = {
  error?: { error: AxiosError };
  onReanalyze?: () => void;
};

const RlCloudSandboxScreenshots: React.FC<Props> = ({
  hash,
  isNetwork,
  activeAnalysisId,
  loadingIndicator = false
}) => {
  const [isReanalyzeOpen, setIsReanalyzeOpen] = useState(false);
  const handleOpenReanalyze = useCallback(() => setIsReanalyzeOpen(true), []);
  const handleCloseReanalyze = useCallback(() => setIsReanalyzeOpen(false), []);

  const ErrorFallback = useMemo(
    () => (props: ErrorFallbackProps) =>
      <ScreenshotsErrorMessage {...props} onReanalyze={handleOpenReanalyze} />,
    [handleOpenReanalyze]
  );

  return (
    <>
      <div className="rl-cloud-sandbox__modal-content">
        <LoadingAndErrorBoundary
          key={activeAnalysisId}
          errorFallback={ErrorFallback}
          suspenseFallback={
            loadingIndicator ? <LoadingIndicator /> : <LoadingOverlay />
          }
        >
          <RlCloudSandboxCarouselWrapper
            hash={hash}
            activeAnalysisId={activeAnalysisId}
            isNetwork={isNetwork}
          />
        </LoadingAndErrorBoundary>
      </div>
      <RenderWhen condition={isReanalyzeOpen}>
        <Reanalyze
          samples={[{ hash_value: hash }]}
          onClose={handleCloseReanalyze}
          initial={{
            ...INITIAL_ANALYSIS_SELECTIONS,
            rl_dynamic_analysis: true
          }}
        />
      </RenderWhen>
    </>
  );
};

export default RlCloudSandboxScreenshots;
